import * as React from 'react';
import './spinner.css';

export const ThreeDotsSpinner = () => <div className="dot-elastic" />;
